module.exports = __webpack_public_path__ + "static/img/ymd.d053918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/ymd.png
// module id = t4DV
// module chunks = 1